import { connect } from 'react-redux';
import { ACTIONS } from '../../actions/reducers';
import { Orders as OrdersComponent } from './orders.component';
import { retrieveData } from '../dashboard.actions';

// Card #101 — the persisted `order.orders` slice (read only by the Chrome
// extension) has two kinds of writer: the generic account-wide pull that runs
// once per page load (retrieveData) and screen-scoped pushes that mirror what
// the user is actually looking at (the Schedules day, the customer Orders list).
// On a full page load both start at once and the account-wide pull is far
// slower, so it landed last and replaced the selected day with the whole
// account. Every write bumps this counter so the slow generic pull can tell
// whether a more specific writer beat it to the slice and stand down.
let ordersWriteSeq = 0;
export const ordersWriteSeqNow = () => ordersWriteSeq;

// `scope` is an optional label describing what this set represents (the
// Schedules screen passes its selected day). Writers that hold no meaningful
// scope omit it and the extension falls back to showing just the count.
export const setOrders = (orders, scope) => dispatch => {
  ordersWriteSeq += 1;
  dispatch({ type: ACTIONS.SET_ORDERS, orders, scope });
}

export const Orders = connect(sState => ({ sState }), { retrieveData, setOrders })(OrdersComponent);